<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="员工姓名">
              <j-search-select-tag type="list" v-model="queryParam.userId" dict="sys_user,realname,id,del_flag=0" placeholder="请选择用户"/>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="身份证号">
              <a-input placeholder="请输入身份证号" v-model="queryParam.cardNo"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="签约状态">
              <j-dict-select-tag type="list"v-model="queryParam.signStatus" dictCode="sign_status" placeholder="请选择签约状态"/>
            </a-form-item>
          </a-col>
        <template v-if="toggleSearchStatus">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="学历">
              <j-dict-select-tag type="list" placeholder="请选择学历" v-model="queryParam.education" dictCode="education" />
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="入职时间">
              <a-range-picker
                style="width: 210px"
                v-model="entryTimeRange"
                format="YYYY-MM-DD"
                :placeholder="['开始时间', '结束时间']"
                @change="onDateChange"
              />
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="执业编号">
              <a-input placeholder="请输入执业编号" v-model="queryParam.practiceNo"></a-input>
            </a-form-item>
          </a-col>
        </template>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>

        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('员工档案')">导出</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>
      <!--<a-dropdown v-if="selectedRowKeys.length > 0">-->
        <!--<a-menu slot="overlay">-->
          <!--<a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>-->
        <!--</a-menu>-->
        <!--<a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>-->
      <!--</a-dropdown>-->
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        @change="handleTableChange">

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
                <a-popconfirm title="确定解约吗?" @confirm="() => changeSignStatus(record)" v-if="record.signStatus==0">
                  <a>解约</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>
    <!-- table区域-end -->

    <!-- 表单区域 -->
    <hRUserProfile-modal ref="modalForm" @ok="modalFormOk"></hRUserProfile-modal>
  </a-card>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import HRUserProfileModal from './modules/HRUserProfileModal'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { mixinDevice } from '@/utils/mixin'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"
  import JSearchSelectTag from "@/components/dict/JSearchSelectTag"
  import {getAction} from '@/api/manage'
  import {frozenBatch} from '@/api/api'

  export default {
    name: "HRUserProfileList",
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      HRUserProfileModal,
      JDictSelectTag,
      JSearchSelectTag
    },
    data () {
      return {
        description: '员工档案管理页面',
        entryTimeRange:[],
        queryParam:{
          userId:'',
          cardNo:'',
          signStatus:'',
          education:'',
          entryTime_begin:'', //入职时间起始日期时间
          entryTime_end:'',
          practiceNo:''
        },

        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
           },
		      {
            title: '员工姓名',
            align:"center",
            dataIndex: 'userId_dictText'
           },
		      {
            title: '身份证号',
            align:"center",
            dataIndex: 'cardNo'
           },
		      {
            title: '政治面貌',
            align:"center",
            dataIndex: 'politicalStatus_dictText'
           },
		      {
            title: '签约状态',
            align:"center",
            dataIndex: 'signStatus_dictText'
           },
		      {
            title: '学历',
            align:"center",
            dataIndex: 'education_dictText'
           },
		      {
            title: '毕业院校',
            className:"column-text",
            dataIndex: 'university'
           },
		      {
            title: '专业',
            className:"column-text",
            dataIndex: 'specialty'
           },
		      {
            title: '毕业时间',
            align:"center",
            dataIndex: 'graduationDate'
           },
		      {
            title: '参加工作时间',
            align:"center",
            dataIndex: 'startWorkingDate'
           },
		      {
            title: '工龄',
            align:"center",
            dataIndex: 'workingAge'
           },
		      {
            title: '岗位类型',
            align:"center",
            dataIndex: 'positionType_dictText'
           },
		      {
            title: '入职时间',
            align:"center",
            dataIndex: 'entryTime'
           },
		      {
            title: '转正时间',
            align:"center",
            dataIndex: 'regularTime'
           },
		      {
            title: '离职时间',
            align:"center",
            dataIndex: 'quitTime'
           },
		      {
            title: '用工方式',
            align:"center",
            dataIndex: 'employmentMode_dictText'
           },
		      {
            title: '合同截止日期',
            align:"center",
            dataIndex: 'laborContractDeadline'
           },
		      {
            title: '是否签订保密协议',
            align:"center",
            dataIndex: 'signSecrecyAgreement_dictText'
           },
		      {
            title: '执业编号',
            className:"column-text",
            dataIndex: 'practiceNo'
           },
		      {
            title: '培训经历',
            className:"column-text",
            dataIndex: 'trainingExperience'
           },
		      {
            title: '奖惩经历',
            className:"column-text",
            dataIndex: 'rewardExperience'
           },
          {
            title: '特标',
            align:"center",
            dataIndex: 'mark_dictText'
           },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' },
          }
        ],
		    url: {
          list: "/hr/hRUserProfile/list",
          delete: "/hr/hRUserProfile/delete",
          deleteBatch: "/hr/hRUserProfile/deleteBatch",
          exportXlsUrl: "hr/hRUserProfile/exportXls",
          importExcelUrl: "hr/hRUserProfile/importExcel",
          changeSignStatus: 'hr/hRUserProfile/changeSignStatus',
       },
    }
  },
  computed: {
    importExcelUrl: function(){
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
    }
  },
    methods: {
      onDateChange: function (value, dateString) {
        this.entryTimeRange = dateString;
      },
      getQueryParams() {
        if(this.entryTimeRange.length >=2){
          this.queryParam.entryTime_begin = this.entryTimeRange[0] + ' 00:00:00';
          this.queryParam.entryTime_end = this.entryTimeRange[1] + ' 23:59:59';
        }
        this.queryParam.field = this.getQueryField()
        this.queryParam.pageNo = this.ipagination.current
        this.queryParam.pageSize = this.ipagination.pageSize
        return this.queryParam;
      },

      changeSignStatus(record){
        //解约后台同时冻结登录账号
        const SYSUSER_STATUS_FROZENED = 2; //冻结状态为2
        let that = this;
        let param = {id:record.id,userId:record.userId};
        getAction(this.url.changeSignStatus, param).then((res)=>{
          if(res.success){
            frozenBatch({ids: record.userId, status: SYSUSER_STATUS_FROZENED}).then((res2) => {
              if (res2.success) {
                that.$message.info("解约成功，登录账号已冻结")
                that.loadData();
              } else {
                that.$message.warning("解约成功，但冻结账号失败，请到用户管理功能中进行冻结");
              }
            })
          } else{
            that.$message.warning("解约失败")
          }
        })
      },
    }
  }
</script>
<style>
  @import '~@assets/less/common.less';

  th.column-text {
    text-align: center !important;
  }
  td.column-text {
    text-align: left !important;
  }
</style>